import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useStore } from '../contexts/StoreContext';
export function CompareBar() {
  const {
    compareIds,
    vehicles,
    toggleCompare,
    setCompareIds
  } = useStore();
  const location = useLocation();
  const selected = compareIds.map(id => vehicles.find(v => v.id === id)).filter((v): v is NonNullable<typeof v> => !!v);
  const show = selected.length > 0 && !location.pathname.startsWith('/comparar') && !location.pathname.startsWith('/admin');
  return <AnimatePresence data-id="element-447" data-mp="10l53ogixkavc">
      {show && <motion.div className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-ink/95 backdrop-blur-md" initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-448" data-mp="10o0yhvzhejfk">
          <div className="container-x flex items-center gap-3 py-3" data-id="element-449" data-mp="2q1nx3kzo90s6">
            <div className="flex min-w-0 flex-1 gap-2 overflow-x-auto" data-id="element-450" data-mp="28wk5iqw72adc">
              {selected.map(v => <span key={v.id} className="inline-flex shrink-0 items-center gap-2 rounded-full border border-line bg-panel py-1 pl-1 pr-2 text-xs" data-id="element-451" data-mp="2d0061ybdwuvb">
                  <img src={v.images[0]} alt="" className="h-6 w-6 rounded-full object-cover" data-id="element-452" data-mp="23yacalu15jud" />
                  {v.model}
                  <button onClick={() => toggleCompare(v.id)} aria-label={`Quitar ${v.model}`} className="text-mist hover:text-white" data-id="element-453" data-mp="2rnuwt95u0p5r">
                    <XIcon className="h-3.5 w-3.5" data-id="element-454" data-mp="2wmej5aoc82yn" />
                  </button>
                </span>)}
            </div>
            <button onClick={() => setCompareIds([])} className="hidden text-xs text-mist hover:text-white sm:block" data-id="element-455" data-mp="2mxefvf2sylen">
              Limpiar
            </button>
            <Link to="/comparar" className="btn btn-primary h-10 shrink-0" data-id="element-456" data-mp="3alnzqbgggz35">
              Comparar ({selected.length})
            </Link>
          </div>
        </motion.div>}
    </AnimatePresence>;
}